<template>
    <div class="home d-flex" v-resize="onResize">
        <v-card class="d-flex flex-grow-1">
            <v-container fluid class="d-flex flex-grow-1">
                <v-row dense class="d-flex flex-grow-1" style="width: 100%">
                    <v-col lg="8" md="8" xs="12" cols="12">
                        <v-card
                            class="d-flex flex-column"
                            style="height: 100%"
                            outlined
                            id="monitorHomeTutorial"
                        >
                            <v-card-title
                                style="border-bottom: 1px solid #404040"
                                class="pt-1"
                            >
                                <div
                                    class="text-left"
                                    style="
                                        margin-left: 0;
                                        width: 50%;
                                        font-size: 13px;
                                        font-weight: normal;
                                    "
                                >
                                    <v-menu
                                        offset-y
                                        dense
                                        v-if="showSymbolLoginSwitch"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                small
                                                color="primary"
                                                dark
                                                v-bind="attrs"
                                                v-on="on"
                                                class="ml-1"
                                            >
                                                {{ selectedMode?.title }}
                                                {{ $t("common.word.mode") }}
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-list-item
                                                v-for="item in modes"
                                                :key="item.value"
                                                @click="
                                                    () => {
                                                        selectedMode = item;
                                                    }
                                                "
                                            >
                                                <v-list-item-title>{{
                                                    item.title
                                                }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <div v-else>
                                        {{ $t("monitor.home.title") }}
                                    </div>
                                </div>
                                <div
                                    class="text-right"
                                    style="margin-right: 0; width: 50%"
                                >
                                    <span id="monitorFunctions">
                                        <v-tooltip
                                            top
                                            v-if="
                                                !VUETIFY_BREAKPOINT.mobile &&
                                                allowDownloadAll
                                            "
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    color="primary"
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="mr-1"
                                                    @click="downloadAllBooks"
                                                    >mdi-cloud-download</v-icon
                                                >
                                            </template>
                                            <span>{{
                                                $t("monitor.home.downloadAll")
                                            }}</span>
                                        </v-tooltip>

                                        <v-tooltip
                                            top
                                            v-if="!VUETIFY_BREAKPOINT.mobile"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    color="green"
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="mr-1"
                                                    @click="startDownload"
                                                    >mdi-microsoft-excel</v-icon
                                                ><download-excel
                                                    id="csvExport"
                                                    :fetch="fetchData"
                                                    :fields="computedCSVFields"
                                                    type="csv"
                                                    style="display: none"
                                                    :name="downloadExcelName"
                                                    :escapeCsv="false"
                                                >
                                                </download-excel>
                                            </template>
                                            <span>{{
                                                $t(
                                                    "monitor.home.downloadCurrent"
                                                )
                                            }}</span>
                                        </v-tooltip>
                                        <v-menu offset-y dense>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    small
                                                    color="default"
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="ml-1"
                                                >
                                                    {{
                                                        detailIntervalOptions.find(
                                                            (option) =>
                                                                option.value ===
                                                                selectedDetailInterval
                                                        ).key
                                                    }}
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-item
                                                    v-for="item in detailIntervalOptions"
                                                    :key="item.key"
                                                    @click="
                                                        () => {
                                                            selectedDetailInterval =
                                                                item.value;
                                                        }
                                                    "
                                                >
                                                    <v-list-item-title>{{
                                                        item.key
                                                    }}</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </span>
                                </div>
                            </v-card-title>

                            <v-row
                                class="flex-shrink-0 flex-grow-0"
                                align="center"
                                style="margin: 0"
                            >
                                <v-col
                                    :cols="briefCol"
                                    class="pl-6"
                                    style="padding: 0"
                                >
                                    <DanMenu
                                        :name="selectedBookName"
                                        :menu-items="books"
                                        @dan-menu-click="onMenuItemClick"
                                    />
                                </v-col>
                                <v-col
                                    :cols="briefCol"
                                    align="center"
                                    style="padding: 0"
                                >
                                    <CardHead
                                        :name="$t('monitor.home.unrealized')"
                                        :value="mainBookTitle.unrealized"
                                        :description="
                                            mainBookTitleDesc.unrealized
                                        "
                                    />
                                </v-col>
                                <v-col
                                    :cols="briefCol"
                                    align="center"
                                    style="padding: 0"
                                >
                                    <CardHead
                                        :name="$t('monitor.home.realized')"
                                        :value="mainBookTitle.realized"
                                        :description="
                                            mainBookTitleDesc.realized
                                        "
                                    />
                                </v-col>
                                <v-col
                                    :cols="briefCol"
                                    align="center"
                                    style="padding: 0"
                                >
                                    <CardHead
                                        :name="$t('monitor.home.dailyNet')"
                                        :value="mainBookTitle.dailyNet"
                                        :description="
                                            mainBookTitleDesc.dailyNet
                                        "
                                    />
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>

                            <!-- PK主表逻辑 -->
                            <v-data-table
                                dense
                                :mobile-breakpoint="0"
                                :headers="mainHeader"
                                :items="computedPKData"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :header-props="{ sortIcon: null }"
                                :custom-filter="filterTable"
                                :customSort="customSort"
                                item-key="symbol"
                                @click:row="rowClicked"
                                class="elevation-0 flex-grow-1"
                                :items-per-page="30"
                                :footer-props="{
                                    itemsPerPageOptions: [10, 20, 30],
                                    showFirstLastPage: false,
                                    'items-per-page-text': '',
                                }"
                                :class="{
                                    'fix-first-col': true,
                                }"
                                id="home-table"
                                :height="tableHeight"
                                fixed-header
                                v-sortable-table="{
                                    onEnd: sortPKHeadersAndUpdateTheKey,
                                }"
                                :key="anIncreasingNumberForMain"
                            >
                                <template v-slot:header.symbol="{ header }">
                                    {{ header.text }}
                                    <v-menu
                                        offset-y
                                        :close-on-content-click="false"
                                        top
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                                @click.prevent="
                                                    onSearch('symbolSearch')
                                                "
                                                id="symbolSearch"
                                            >
                                                mdi-magnify
                                            </v-icon>
                                        </template>
                                        <div
                                            style="
                                                background-color: #1e1e1e;
                                                width: 280px;
                                            "
                                        >
                                            <v-text-field
                                                v-model="search"
                                                class="px-4"
                                                type="text"
                                                ref="symbolSearch"
                                                :label="
                                                    $t(
                                                        'common.phrase.enterSearchTerm'
                                                    )
                                                "
                                                style="width: 100%"
                                                single-line
                                                hide-details
                                            ></v-text-field>
                                            <v-btn
                                                @click="search = ''"
                                                small
                                                text
                                                color="primary"
                                                class="ml-2 mb-2"
                                                style="padding: 6px"
                                            >
                                                {{ $t("common.form.clean") }}
                                            </v-btn>
                                        </div>
                                    </v-menu>
                                </template>
                                <template v-slot:header.Login="{ header }">
                                    {{ header.text }}
                                    <v-menu
                                        offset-y
                                        :close-on-content-click="false"
                                        top
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                                @click.prevent="
                                                    onSearch('loginSearch')
                                                "
                                                id="loginSearch"
                                            >
                                                mdi-magnify
                                            </v-icon>
                                        </template>
                                        <div
                                            style="
                                                background-color: #1e1e1e;
                                                width: 280px;
                                            "
                                        >
                                            <v-text-field
                                                v-model="search"
                                                class="px-4"
                                                type="text"
                                                ref="loginSearch"
                                                :label="
                                                    $t(
                                                        'common.phrase.enterSearchTerm'
                                                    )
                                                "
                                                style="width: 100%"
                                                single-line
                                                hide-details
                                            ></v-text-field>
                                            <v-btn
                                                @click="search = ''"
                                                small
                                                text
                                                color="primary"
                                                class="ml-2 mb-2"
                                                style="padding: 6px"
                                            >
                                                {{ $t("common.form.clean") }}
                                            </v-btn>
                                        </div>
                                    </v-menu>
                                </template>
                                <template
                                    v-slot:header.floatingProfitEOD="{ header }"
                                >
                                    <span class="no_break">{{
                                        header.text
                                    }}</span>
                                </template>
                                <template
                                    v-slot:header.MarginLevel="{ header }"
                                >
                                    <span class="no_break">{{
                                        header.text
                                    }}</span>
                                </template>
                                <template v-slot:header.MarginFree="{ header }">
                                    <span class="no_break">{{
                                        header.text
                                    }}</span>
                                </template>
                                <template
                                    v-slot:header.closedProfitEOD="{ header }"
                                >
                                    <span class="no_break">{{
                                        header.text
                                    }}</span>
                                </template>
                                <template
                                    v-slot:header.floatingProfit="{ header }"
                                >
                                    <span class="no_break">{{
                                        header.text
                                    }}</span>
                                </template>
                                <template
                                    v-slot:header.closedProfit="{ header }"
                                >
                                    <span class="no_break">{{
                                        header.text
                                    }}</span>
                                </template>
                                <template
                                    v-slot:header.TodayTotalMTPNL="{ header }"
                                >
                                    <span class="no_break">{{
                                        header.text
                                    }}</span>
                                </template>
                                <template
                                    v-slot:header.dailyVolumeUSD="{ header }"
                                >
                                    <span class="no_break">{{
                                        header.text
                                    }}</span>
                                </template>
                                <template v-slot:header.net="{ header }">
                                    <v-tooltip top open-delay="500">
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <span v-bind="attrs" v-on="on">{{
                                                header.text
                                            }}</span>
                                        </template>
                                        <span>{{
                                            $t("monitor.home.netVolumeHeader")
                                        }}</span>
                                    </v-tooltip>
                                </template>
                                <!-- PK表鼠标点击后的副表 -->
                                <template v-slot:item.symbol="{ item }">
                                    <v-tooltip right open-delay="500">
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <a
                                                v-bind="attrs"
                                                v-on="on"
                                                @click.stop="
                                                    () => {
                                                        getEODSymbolMaps(
                                                            item.symbol
                                                        );
                                                    }
                                                "
                                                style="
                                                    background: transparent;
                                                    padding: 0px;
                                                    color: white;
                                                "
                                                id="symbolEODDialog"
                                            >
                                                {{ item.symbol }}</a
                                            >
                                        </template>
                                        <TooltipTable :monitor-item="item" />
                                    </v-tooltip>
                                </template>
                                <template v-slot:item.net="{ item }">
                                    {{ item.netStr }}
                                </template>
                                <template v-slot:item.dailyNet="{ item }">
                                    <div v-bind:class="`${item.color}`">
                                        {{ item.dailyNetStr }}
                                    </div>
                                </template>
                                <template v-slot:item.longPositions="{ item }">
                                    {{ item.longPositionsStr }}
                                </template>
                                <template v-slot:item.shortPositions="{ item }">
                                    {{ item.shortPositionsStr }}
                                </template>
                                <template
                                    v-slot:item.floatingProfitEOD="{ item }"
                                >
                                    {{ item.floatingProfitEODStr }}
                                </template>
                                <template
                                    v-slot:item.closedProfitEOD="{ item }"
                                >
                                    <div
                                        v-bind:class="`${item.realizedColor}`"
                                        style="cursor: pointer"
                                        @click.stop="
                                            () => {
                                                getPNLSummary(item);
                                            }
                                        "
                                    >
                                        {{ item.closedProfitEODStr }}
                                    </div>
                                </template>
                                <template v-slot:item.closedProfit="{ item }">
                                    {{ item.closedProfitStr }}
                                </template>
                                <template v-slot:item.floatingProfit="{ item }">
                                    {{ item.floatingProfitStr }}
                                </template>
                                <template v-slot:item.symbolExposure="{ item }">
                                    {{ item.symbolExposureStr }}
                                </template>
                                <template
                                    v-slot:item.weightedAvgLongPrice="{ item }"
                                >
                                    {{ item.weightedAvgLongPriceStr }}
                                </template>
                                <template
                                    v-slot:item.weightedAvgShortPrice="{ item }"
                                >
                                    {{ item.weightedAvgShortPriceStr }}
                                </template>
                                <template v-slot:item.Exposure="{ item }">
                                    {{
                                        numberWithCommas(
                                            item.Exposure.toFixed(2)
                                        )
                                    }}
                                </template>
                                <template
                                    v-slot:item.TodayTotalMTPNL="{ item }"
                                >
                                    {{
                                        numberWithCommas(
                                            item.TodayTotalMTPNL.toFixed(2)
                                        )
                                    }}
                                </template>
                                <template v-slot:item.Equity="{ item }">
                                    {{
                                        numberWithCommas(item.Equity.toFixed(2))
                                    }}
                                </template>
                                <template v-slot:item.MarginLevel="{ item }">
                                    {{
                                        numberWithCommas(
                                            item.MarginLevel.toFixed(2)
                                        )
                                    }}
                                </template>
                                <template v-slot:item.Credit="{ item }">
                                    {{
                                        numberWithCommas(item.Credit.toFixed(2))
                                    }}
                                </template>
                                <template v-slot:item.MarginFree="{ item }">
                                    {{
                                        numberWithCommas(
                                            item.MarginFree.toFixed(2)
                                        )
                                    }}
                                </template>
                                <template v-slot:item.dailyVolumeUSD="{ item }">
                                    {{
                                        numberWithCommas(
                                            (item.dailyVolumeUSD ?? 0).toFixed(
                                                2
                                            )
                                        )
                                    }}
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col lg="4" md="4" xs="12" cols="12">
                        <div class="d-flex flex-column flex-grow-1">
                            <AllBooks
                                ref="allBooks"
                                :mtdPnl="mtdPnl"
                                :mtdVolume="mtdVolume"
                                @changeBook="changeSelectedBook"
                                :tableHeight="allBookTableHeight"
                                id="allBookHomeTutorial"
                            />
                            <FunctionTabs
                                id="functionalTabsHomeTutorial"
                                class="mt-2"
                                :style="{
                                    'margin-top': '10px',
                                    height: functionTabHeight + 'px',
                                }"
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <!-- PK monitor table modal when click realized number -->
        <v-dialog
            v-model="dialogCloseSummaryVisible"
            :width="dialogWidth"
            :hide-overlay="true"
            :persistent="true"
            :fullscreen="fullscreen"
        >
            <v-card>
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0"
                        >{{ $t("monitor.home.closeSummary") }} -
                        {{ closeSummarySymbol }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="white"
                        icon
                        @click="dialogCloseSummaryVisible = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-container>
                    <v-row>
                        <v-col cols="12" class="pt-0 pb-0 pl-0">
                            <v-tabs>
                                <v-tab dense v-on:click="changeTab('login')">{{
                                    $t("monitor.home.pnlByLogin")
                                }}</v-tab>
                                <v-tab dense v-on:click="changeTab('symbol')">{{
                                    $t("monitor.home.pnlBySymbol")
                                }}</v-tab>
                            </v-tabs>
                        </v-col>
                    </v-row>
                    <v-row v-if="selectedKey === 'login'" class="mt-5">
                        <v-col cols="12" class="pt-0 pb-0">
                            <v-data-table
                                :headers="closeSummaryLoginHeaders"
                                :items="closeSummaryLoginData"
                                dense
                                :header-props="{ sortIcon: null }"
                                :search="searchCloseSummaryLogin"
                                :items-per-page="15"
                                :loading="loading"
                                :mobile-breakpoint="0"
                                :footer-props="{
                                    'items-per-page-text': '',
                                }"
                                :class="{
                                    'fix-first-col': VUETIFY_BREAKPOINT.mobile,
                                }"
                            >
                                <template v-slot:header.login="{ header }">
                                    {{ header.text }}
                                    <v-menu
                                        offset-y
                                        :close-on-content-click="false"
                                        top
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                                @click.prevent="
                                                    onSearch('loginSearch')
                                                "
                                            >
                                                mdi-magnify
                                            </v-icon>
                                        </template>
                                        <div
                                            style="
                                                background-color: #1e1e1e;
                                                width: 280px;
                                            "
                                        >
                                            <v-text-field
                                                v-model="
                                                    searchCloseSummaryLogin
                                                "
                                                class="px-4"
                                                type="text"
                                                ref="loginSearch"
                                                :label="
                                                    $t(
                                                        'common.phrase.enterSearchTerm'
                                                    )
                                                "
                                                style="width: 100%"
                                                single-line
                                                hide-details
                                            ></v-text-field>
                                            <v-btn
                                                @click="
                                                    searchCloseSummaryLogin = ''
                                                "
                                                small
                                                text
                                                color="primary"
                                                class="ml-2 mb-2"
                                                style="padding: 6px"
                                            >
                                                {{ $t("common.form.clean") }}
                                            </v-btn>
                                        </div>
                                    </v-menu>
                                </template>
                                <template v-slot:item.profit="{ item }">
                                    {{
                                        numberWithCommas(item.profit.toFixed(2))
                                    }}
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row v-if="selectedKey === 'symbol'" class="mt-5">
                        <v-col cols="12" class="pt-0 pb-0">
                            <v-data-table
                                :headers="closeSummarySymbolHeaders"
                                :items="closeSummarySymbolData"
                                dense
                                :header-props="{ sortIcon: null }"
                                :items-per-page="10"
                                :loading="loading"
                                :mobile-breakpoint="0"
                                :footer-props="{
                                    'items-per-page-text': '',
                                }"
                                :class="{
                                    'fix-first-col': VUETIFY_BREAKPOINT.mobile,
                                }"
                            >
                                <template v-slot:item.profit="{ item }">
                                    {{
                                        numberWithCommas(item.profit.toFixed(2))
                                    }}
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- EOD Symbol map -->
        <v-dialog
            v-model="symbolMap"
            :width="800"
            :hide-overlay="true"
            :persistent="true"
            :fullscreen="fullscreen"
        >
            <v-card>
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0"
                        >{{ $t("monitor.home.eodSymbolPriceMap") }} -
                        {{ selectedSymbolMap }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="white" icon @click="symbolMap = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-container>
                    <v-row>
                        <v-col cols="12" class="pt-0 pb-0">
                            <v-data-table
                                :headers="symbolMapHeader"
                                :items="
                                    !!selectedSymbolMap
                                        ? computedSymbolPriceMapData[
                                              selectedSymbolMap
                                          ]
                                        : []
                                "
                                dense
                                :header-props="{ sortIcon: null }"
                                :items-per-page="15"
                                :mobile-breakpoint="0"
                                :footer-props="{
                                    'items-per-page-text': '',
                                }"
                                :class="{
                                    'fix-first-col': VUETIFY_BREAKPOINT.mobile,
                                }"
                            >
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <LoginSummaryDialog
            v-if="loginSummaryHistoryVisible"
            :fullLogin="fullLoginValue"
            :login="loginValue"
            :server="serverValue"
            :symbol="symbolValue"
            :book="selectedBook"
        />

        <SymbolDetailDialog
            :visible.sync="monitorDialog"
            :symbolLogin="currentExpanded"
            :symbolLoginDetailArray="symbolLoginDetailArray"
            :table-loading="monitorDialogLoading"
            :showHomeLoginDetailSummary="showHomeLoginDetailSummary"
            @login-click="loadLoginSummaryHistoryDialog"
            :selectedBook="selectedBook"
            :mode="this.selectedMode.title"
        />
        <a id="downloadAnchorElement" style="display: none"></a>
        <a id="homeSymbolBriefDownload" style="display: none"></a>
    </div>
</template>
<script>
import { getMTDPnl } from "@services/statistic/mtd-pnl";
import { getMTDVolume } from "@services/statistic/mtd-volume";
import dayjs from "dayjs";
import md5 from "md5";
import { helper } from "@components/mixins/helper";
import { permission } from "@components/mixins/permission";
import { mapActions, mapMutations, mapState } from "vuex";
import CardHead from "./home/ComponentCardHead";
import common from "@assets/js/common";
import LoginSummaryDialog from "@components/login-summary/ComponentLoginSummaryDialog";
import FunctionTabs from "@components/home/FunctionTabs";
import { position } from "@components/mixins/position";
import { snackbar } from "@components/mixins/snackbar";
import deepClone from "deep-clone";
import AllBooks from "./home/ComponentAllBooks";
import DanMenu from "./home/ComponentDanMenu";
import SymbolDetailDialog from "./home/ComponentSymbolDetailDialog";
import TooltipTable from "./home/ComponentTooltipTable";
import introJs from "intro.js";
import { TutorialConstant } from "@assets/tutorialConstant";
import { putAuthUser, getWsToken } from "@services/account/auth";

export default {
    name: "Home",
    components: {
        FunctionTabs,
        LoginSummaryDialog,
        CardHead,
        DanMenu,
        AllBooks,
        SymbolDetailDialog,
        TooltipTable,
    },
    mixins: [helper, position, permission, snackbar],
    data() {
        return {
            allBookDownloadLoading: false,
            allowDownloadAll: false,
            showSymbolLoginSwitch: false,
            tutorialConstant: TutorialConstant,
            modes: [
                // { title: "ACCOUNT", value: "ACCOUNT_ID" },
                // { title: "PARTNER", value: "PARTNER_ID" },
                // { title: "BACK OFFICE", value: "BACK_OFFICE_ID" },
                { title: "Symbol", value: "NOT_IB" },
                { title: "Login", value: "LOGIN" },
            ],
            symbolMap: false,
            csvFieldsDialog: false,
            selectedCSVFields: [],
            computedCSVFields: {},
            inputCsvName: "",
            selectAll: true,
            loginSummaryHistoryVisible: false,
            pkSocket: null,
            lockReconnect: false, // 避免 socket 重复连接
            selectedBook: "",
            selectedSymbolMap: null,
            sortBy: "symbolExposure",
            sortDesc: true,
            fullscreen: false,
            symbolMapHeader: [
                {
                    text: this.$t("common.table.symbol"),
                    align: "start",
                    sortable: false,
                    value: "symbolName",
                },
                {
                    text: this.$t("common.table.ask"),
                    value: "ask",
                    align: "end",
                    sortable: true,
                },
                {
                    text: this.$t("common.table.bid"),
                    value: "bid",
                    align: "end",
                    sortable: true,
                },
                {
                    text: this.$t("common.table.date"),
                    value: "dateTime",
                    align: "end",
                    sortable: true,
                },
            ],
            selectedMode: { title: "Symbol", value: "NOT_IB" },
            pkData: [],
            pkDataIndexMap: new Map(), // symbol -> index 映射，加速查找
            processingBatchId: 0, // 用于取消过时的批处理
            loadSubTable: false,
            search: "",
            currentExpanded: "",
            monitorDialogLoading: false,
            symbolLoginDetailOriginHash: "",
            symbolLoginDetailArray: [],
            showHomeLoginDetailSummary: false,
            dialogCloseSummaryVisible: false,
            closeSummaryLoginData: [],
            closeSummaryLoginHeaders: [
                {
                    text: this.$t("common.table.login"),
                    align: "start",
                    sortable: false,
                    value: "login",
                },
                {
                    text: this.$t("common.table.realizedEod"),
                    value: "realized_eod",
                    align: "end",
                    sortable: true,
                },
                {
                    text: this.$t("common.table.realizedMT"),
                    value: "realized_mt4",
                    align: "end",
                    sortable: true,
                },
            ],
            searchCloseSummaryLogin: "",
            closeSummarySymbolData: [],
            closeSummarySymbolHeaders: [
                {
                    text: this.$t("common.table.symbol"),
                    align: "start",
                    sortable: false,
                    value: "symbol",
                },
                {
                    text: this.$t("common.table.realizedEod"),
                    value: "realized_eod",
                    align: "end",
                    sortable: true,
                },
                {
                    text: this.$t("common.table.realizedMT"),
                    value: "realized_mt4",
                    align: "end",
                    sortable: true,
                },
            ],
            selectedKey: "login",
            dialogWidth: "450px",
            closeSummarySymbol: "",
            loadLoginHistoryChart: 0,
            fullLoginValue: "",
            loginValue: "",
            serverValue: "",
            symbolValue: "",
            bookList: [],
            isDataStreaming: null,
            mtdVolume: [],
            mtdPnl: [],
            tableHeight: 616,
            allBookTableHeight: 200,
            functionTabHeight: 400,
            anIncreasingNumberForMain: 1,
            anIncreasingNumberForSub: 1,
            mainHeader: null,
            allowSymbolDetailsDownload: false,
            isCsvRecording: false,
            symbolLoginDetails: null,
            allBookHBInterval: null,
            detailHBInterval: null,
            selectedDetailInterval: 1000,
            detailIntervalOptions: [
                { key: this.$t("common.time.03s"), value: 300 },
                { key: this.$t("common.time.05s"), value: 500 },
                { key: this.$t("common.time.1s"), value: 1000 },
                { key: this.$t("common.time.5s"), value: 5000 },
                { key: this.$t("common.time.10s"), value: 10000 },
                { key: this.$t("common.time.push"), value: -1 },
            ],
            mainBookTitle: { unrealized: 0, realized: 0, dailyNet: 0 },
            monitorDialog: false,
            showMtdVolume: false,
            showMtdPnl: false,
            showNetEquity: false,
            bookMainTimeout: null,
        };
    },
    computed: {
        ...mapState("Home", [
            "books",
            "pkHeaders",
            "socketUrl",
            "socketLoginUrl",
            "mainBookTitleDesc",
            "csvFields",
            "csvLoginFields",
            "isSocketConnected",
            "loading",
            "PNLSummaryData",
            "selectedProfile",
            "allProfile",
            "allBookOptions",
            "selectedInterval",
            "homeTutorial",
            "lotDigits",
            "pkLoginHeaders",
            "exposureData",
        ]),
        downloadExcelName() {
            return `${this.inputCsvName.replaceAll(" ", "_")}.csv`;
        },
        selectedBookName() {
            return `${this.selectedBook} BOOK`;
        },
        computedPKData() {
            if (this.search) {
                const computed =
                    this.selectedMode.title === "Symbol"
                        ? this.pkData.filter((item) =>
                              item.symbol
                                  .toUpperCase()
                                  .includes(this.search.toUpperCase())
                          )
                        : this.pkData.filter((item) =>
                              item.Login.toString().includes(
                                  this.search.toString()
                              )
                          );
                // console.log(computed);
                return computed;
            }
            return this.pkData;
        },
        computedSymbolPriceMapData() {
            const symbolMap = {};
            this.pkData.map((item) => {
                symbolMap[item.symbol] = item._eodPriceList.map((price) => {
                    price.ask = parseFloat(price.ask).toFixed(item.digits);
                    price.bid = parseFloat(price.bid).toFixed(item.digits);
                    return price;
                });
            });
            return symbolMap;
        },
        briefCol() {
            return this.VUETIFY_BREAKPOINT.mobile ? 6 : 3;
        },
    },
    watch: {
        "VUETIFY_BREAKPOINT.mobile": {
            immediate: true,
            handler(val) {
                if (val) {
                    this.fullscreen = true;
                }
            },
        },
        PNLSummaryData(nv) {
            if (nv.length == 0) {
                this.closeSummaryLoginData = [];
                this.closeSummaryRawData = [];
                this.closeSummarySymbolData = [];
            } else {
                if (this.selectedKey == "login") {
                    this.closeSummaryLoginData = nv;
                } else if (this.selectedKey == "symbol") {
                    this.closeSummarySymbolData = nv;
                }
            }
        },
        selectedBook(nv, ov) {
            this.currentExpanded = null;
            clearInterval(this.detailHBInterval);
            if (this.bookMainTimeout) {
                clearTimeout(this.bookMainTimeout);
            }
            if (nv !== null) {
                this.snackBarInfo(
                    this.$t("monitor.home.connectingToSocket"),
                    5000
                );

                // reset all table related data
                this.isDataStreaming = null;
                this.UPDATE_EXPOSURE_DATA({});
                this.pkData = [];
                this.pkDataIndexMap.clear();
                this.mainBookTitle = {
                    unrealized: 0,
                    realized: 0,
                    dailyNet: 0,
                };

                if (this.pkSocket.readyState == 1) {
                    const bookMain = {
                        externalMsgType: "CMD_SUBSCRIBE_BOOKS",
                        books: [
                            this.selectedBook + ":" + this.selectedMode.value,
                        ],
                    };
                    this.pkSocket.send(JSON.stringify(bookMain));
                }
            }
        },
        selectedMode(nv, ov) {
            this.currentExpanded = null;
            clearInterval(this.detailHBInterval);
            if (nv !== null) {
                const mode = nv?.title;
                if (
                    mode === "Login" &&
                    !localStorage.getItem("mainHeader")?.includes("Login")
                ) {
                    this.mainHeader = deepClone(this.pkLoginHeaders);
                }
                if (
                    mode === "Symbol" &&
                    !localStorage.getItem("mainHeader")?.includes("Symbol")
                ) {
                    this.mainHeader = deepClone(this.pkHeaders);
                }
                localStorage.setItem("bookMonitorMode", mode);
                localStorage.setItem(
                    "mainHeader",
                    JSON.stringify(this.mainHeader)
                );

                this.snackBarInfo(
                    this.$t("monitor.home.connectingToSocket"),
                    5000
                );

                // reset all table related data
                this.isDataStreaming = null;
                this.UPDATE_EXPOSURE_DATA({});
                this.pkData = [];
                this.pkDataIndexMap.clear();
                this.mainBookTitle = {
                    unrealized: 0,
                    realized: 0,
                    dailyNet: 0,
                };

                this.createPKWebSocket();
            }
        },
        books(nv, ov) {
            if (nv.length !== 0) {
                // this.selectedBook = nv[0].book_name;
                const filterBook = nv.filter((item) => item.book_name === "B");

                if (filterBook.length !== 0) {
                    this.selectedBook = filterBook[0].book_name;
                } else {
                    this.selectedBook = nv[0].book_name;
                }

                this.bookList = [];
                nv.forEach((item) => {
                    this.bookList.push(item.book_name);
                    if (item.children) {
                        item.children.forEach((detail) => {
                            this.bookList.push(detail.book_name);
                        });
                    }
                });

                // load mtd summary
                if (this.showMtdVolume) {
                    this.loadMTDVolume();
                }
                if (this.showMtdPnl) {
                    this.loadMTDPnl();
                }
                this.createPKWebSocket();
            }
        },
        // 监听close summary对话框是否打开，关闭时清空图表数据
        dialogCloseSummaryVisible(nv, ov) {
            if (!nv) {
                self = this;
                self.closeSummaryLoginData = [];
                self.closeSummarySymbolData = [];
                self.closeSummaryRawData = [];
                self.searchCloseSummaryLogin = "";
            }
        },
        selectedProfile(nv) {
            this.selectedBook = null;

            this.UPDATE_BTN_STATUS(true);
            const remaining = this.allBookOptions.filter((item) => {
                return !nv?.books?.includes(item.book_name);
            });
            this.UPDATE_BOOKS(remaining);
            if (this.pkSocket) {
                this.pkSocket.close();
                this.initConnection();
            }
        },
        isDataStreaming(nv) {
            if (nv === true) {
                this.UPDATE_BTN_STATUS(false);
                this.snackBarSuccess(
                    this.$t("monitor.home.connectionEstablished")
                );
            }
        },
        selectedInterval(nv, ov) {
            clearInterval(this.allBookHBInterval);
            if (ov > 0) {
                if (nv < 0) {
                    const bookBrief = {
                        externalMsgType: "CMD_SUBSCRIBE_BOOKS_BRIEF",
                        books: this.bookList.map(
                            (book) => book + ":" + this.selectedMode.value
                        ),
                    };
                    this.pkSocket.send(JSON.stringify(bookBrief));

                    if (this.selectedDetailInterval > 0) {
                        this.selectedDetailInterval = -1;
                    }
                }
            } else {
                if (nv > 0) {
                    const bookBrief = {
                        externalMsgType: "CMD_SUBSCRIBE_BOOKS_BRIEF",
                        books: this.bookList.map(
                            (book) => book + ":" + this.selectedMode.value
                        ),
                    };
                    this.pkSocket.send(JSON.stringify(bookBrief));

                    if (this.selectedInterval < 0) {
                        this.UPDATE_SELECTED_INTERVAL(1000);
                    }
                    if (this.selectedDetailInterval < 0) {
                        this.selectedDetailInterval = 1000;
                    }
                }
            }
        },
        selectedDetailInterval(nv, ov) {
            clearInterval(this.detailHBInterval);
            if (ov > 0) {
                if (nv < 0) {
                    const bookMain = {
                        externalMsgType: "CMD_SUBSCRIBE_BOOKS",
                        books: [
                            this.selectedBook + ":" + this.selectedMode.value,
                        ],
                    };
                    this.pkSocket.send(JSON.stringify(bookMain));
                    if (this.selectedInterval > 0) {
                        this.UPDATE_SELECTED_INTERVAL(-1);
                    }
                }
            } else {
                if (nv > 0) {
                    const bookMain = {
                        externalMsgType: "CMD_SUBSCRIBE_BOOKS",
                        books: [
                            this.selectedBook + ":" + this.selectedMode.value,
                        ],
                    };
                    this.pkSocket.send(JSON.stringify(bookMain));
                    if (this.selectedInterval < 0) {
                        this.UPDATE_SELECTED_INTERVAL(1000);
                    }
                }
            }
        },
        homeTutorial(nv) {
            if (!!nv) {
                this.getTutorial()
                    .oncomplete(() => this.updateHomeTutorialAction(false))
                    .onexit(() => this.updateHomeTutorialAction(false))
                    .start();
            }
        },
    },
    mounted() {
        this.setHeights();
        setTimeout(() => {
            if (
                !localStorage
                    .getItem("tutorial_presented")
                    .includes("home_page")
            ) {
                this.getTutorial()
                    .oncomplete(function () {
                        const params = { pages: "" };
                        if (!localStorage.getItem("tutorial_presented")) {
                            params.pages = "home_page";
                        } else {
                            params.pages =
                                localStorage.getItem("tutorial_presented") +
                                ",home_page";
                        }
                        putAuthUser(params).then((res) => {
                            if (res.status === 200) {
                                localStorage.setItem(
                                    "tutorial_presented",
                                    params.pages
                                );
                            }
                        });
                    })
                    .onexit(function () {
                        const params = { pages: "" };
                        if (!localStorage.getItem("tutorial_presented")) {
                            params.pages = "home_page";
                        } else {
                            params.pages =
                                localStorage.getItem("tutorial_presented") +
                                ",home_page";
                        }
                        putAuthUser(params).then((res) => {
                            if (res.status === 200) {
                                localStorage.setItem(
                                    "tutorial_presented",
                                    params.pages
                                );
                            }
                        });
                    })
                    .start();
            }
        }, 2000);
    },
    methods: {
        ...mapActions("Home", [
            "getBooksPkAction",
            "calculateAllBooks",
            "getProfileAction",
            "getPNLSummaryAction",
            "updateHomeTutorialAction",
        ]),
        ...mapActions("SettingsServer", ["getServerAction"]),
        ...mapMutations("Home", [
            "UPDATE_SOCKET_CONNECTION_STATUS",
            "UPDATE_ALL_PROFILE",
            "UPDATE_BTN_STATUS",
            "UPDATE_BOOKS",
            "UPDATE_SELECTED_PROFILE",
            "UPDATE_SELECTED_INTERVAL",
            "UPDATE_SYMBOL_SNAPSHOT",
            "UPDATE_LOGIN_SNAPSHOT",
            "UPDATE_EXPOSURE_DATA",
        ]),
        getTutorial() {
            const steps = [
                {
                    element: document.getElementById("monitorHomeTutorial"),
                    title: this.tutorialConstant["home-page-intro"][
                        "monitorHomeTutorial"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "monitorHomeTutorial"
                    ]["intro"],
                },
                {
                    element: document.getElementById("allBookHomeTutorial"),
                    title: this.tutorialConstant["home-page-intro"][
                        "allBookHomeTutorial"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "allBookHomeTutorial"
                    ]["intro"],
                },
                {
                    element: document.getElementById(
                        "functionalTabsHomeTutorial"
                    ),
                    title: this.tutorialConstant["home-page-intro"][
                        "functionalTabsHomeTutorial"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "functionalTabsHomeTutorial"
                    ]["intro"],
                },
                {
                    element: document.getElementById("profileHomeTutorial"),
                    title: this.tutorialConstant["home-page-intro"][
                        "profileHomeTutorial"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "profileHomeTutorial"
                    ]["intro"],
                },
                {
                    element: document.getElementById("home-table"),
                    title: this.tutorialConstant["home-page-intro"][
                        "home-table"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "home-table"
                    ]["intro"],
                },
                {
                    element: document.getElementById("symbolSearch"),
                    title: this.tutorialConstant["home-page-intro"][
                        "symbolSearch"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "symbolSearch"
                    ]["intro"],
                },
                {
                    element: document.getElementById("symbolEODDialog"),
                    title: this.tutorialConstant["home-page-intro"][
                        "symbolEODDialog"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "symbolEODDialog"
                    ]["intro"],
                },
                {
                    element: document.getElementById("monitorFunctions"),
                    title: this.tutorialConstant["home-page-intro"][
                        "monitorFunctions"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "monitorFunctions"
                    ]["intro"],
                },
                {
                    element: document.getElementById("allBookFunction"),
                    title: this.tutorialConstant["home-page-intro"][
                        "allBookFunction"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "allBookFunction"
                    ]["intro"],
                },
            ];

            if (
                !localStorage
                    .getItem("tutorial_presented")
                    .includes("home_page")
            ) {
                steps.unshift({
                    element: document.getElementById("homeTutorialIcon"),
                    title: this.tutorialConstant["home-page-intro"][
                        "homeTutorialIcon"
                    ]["title"],
                    intro: this.tutorialConstant["home-page-intro"][
                        "homeTutorialIcon"
                    ]["intro"],
                });
            }
            return introJs().setOptions({
                steps: steps,
                nextLabel: this.$t("tutorial.next"),
                prevLabel: this.$t("tutorial.prev"),
            });
        },
        async requestAllBookDownload(params) {
            try {
                let url;
                if (process.env.NODE_ENV === "development") {
                    url = "/api/v1/statistic/download-all-books";
                } else {
                    url =
                        document.querySelector("body").getAttribute("apiurl") ||
                        process.env.VUE_APP_ENDPOINT;
                    url = url + "/api/v1/statistic/download-all-books";
                }
                const response = await fetch(url, {
                    method: "POST",
                    body: JSON.stringify(params),
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                // Check if the response is ok
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                return response; // This should be a Response object
            } catch (error) {
                console.error("Error in requestAllBookDownload:", error);
                throw error;
            }
        },
        downloadAllBooks() {
            this.allBookDownloadLoading = true;
            this.snackBarSuccess(
                this.$t("monitor.home.downloadAllMessage"),
                2000
            );
            const timeNow = dayjs()
                .tz("US/Eastern")
                .add(7, "hour")
                .add(-1, "minute")
                .format("YYYY_MM_DD HH_mm_00");

            const params = {
                request_time: timeNow,
            };
            this.requestAllBookDownload(params)
                .then(async (res) => {
                    this.csvFieldsDialog = false;
                    if (res && typeof res.blob === "function") {
                        const blob = await res.blob();
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download =
                            "Book " +
                            this.$t("common.word.summary") +
                            " - " +
                            timeNow +
                            ".xlsx";
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                    } else {
                        throw new Error("The response is not a valid Blob");
                    }
                    this.allBookDownloadLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.allBookDownloadLoading = false;
                    this.snackBarDanger(this.$t("monitor.home.failedRequest"));
                });
        },
        startDownload() {
            this.selectAll = true;
            this.selectedCSVFields = [];
            this.isCsvRecording = true;

            this.inputCsvName =
                "position " + this.selectedBook + " " + this.selectedMode.title;

            if (this.selectedMode.value === "LOGIN") {
                this.computedCSVFields = this.csvLoginFields;
                Object.keys(this.csvLoginFields).map(
                    (item) => (this.selectedCSVFields[item] = true)
                );
            } else {
                this.computedCSVFields = this.csvFields;
                Object.keys(this.csvFields).map(
                    (item) => (this.selectedCSVFields[item] = true)
                );
            }

            document.getElementById("csvExport").click();

            if (this.allowSymbolDetailsDownload && this.monitorDialog) {
                var dataStr =
                    "data:text/json;charset=utf-8," +
                    encodeURIComponent(
                        JSON.stringify(this.symbolLoginDetailArray)
                    );
                var dlAnchorElem = document.getElementById(
                    "downloadAnchorElement"
                );
                dlAnchorElem.setAttribute("href", dataStr);
                dlAnchorElem.setAttribute(
                    "download",
                    "symbolLoginDetails.json"
                );
                dlAnchorElem.click();
            }
        },
        async fetchData() {
            return this.computedPKData;
        },
        sortPKHeadersAndUpdateTheKey(evt) {
            const headersTmp = this.mainHeader;
            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            if (newIndex >= headersTmp.length) {
                let k = newIndex - headersTmp.length + 1;
                while (k--) {
                    headersTmp.push(undefined);
                }
            }
            headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
            localStorage.setItem("mainHeader", JSON.stringify(headersTmp));
            this.anIncreasingNumberForMain += 1;
        },
        // 创建 socket 连接
        createPKWebSocket() {
            try {
                if (
                    "WebSocket" in window &&
                    this.selectedBook &&
                    this.selectedMode
                ) {
                    if (this.selectedMode.title === "Symbol") {
                        this.pkSocket = new WebSocket(this.socketUrl);
                    } else if (this.selectedMode.title === "Login") {
                        this.pkSocket = new WebSocket(this.socketLoginUrl);
                    }
                }
                this.initWSEventHandle();
            } catch (e) {
                this.reconnect();
            }
        },
        // 初始化 socket 事件
        initWSEventHandle() {
            // on socket message coming
            this.pkSocket.onopen = (evt) => {
                this.onWebSocketOpen(evt);
            };

            this.pkSocket.onmessage = (evt) => {
                this.onWebSocketMessage(evt);
            };

            this.pkSocket.onclose = (evt) => {
                this.reconnect();
                console.log("on close: ", evt);
            };

            this.pkSocket.onerror = (evt) => {
                this.reconnect();
                console.log("On error: ", evt);
            };
        },
        // 重连 socket
        reconnect() {
            if (this.lockReconnect) return;
            this.lockReconnect = true;
            setTimeout(() => {
                if (this.pkSocket == null || this.pkSocket.readyState == 3) {
                    console.log("reconnecting...");
                    const lastSelection = this.selectedProfile;
                    this.UPDATE_SELECTED_PROFILE(null);
                    this.UPDATE_SELECTED_PROFILE(lastSelection);
                }
                this.lockReconnect = false;
            }, 1000);
        },
        setHeights() {
            if (!this.VUETIFY_BREAKPOINT.mobile) {
                const innerHeight = window.innerHeight;
                this.tableHeight =
                    innerHeight - 273 > 636 ? innerHeight - 273 : 636;
                // 929 -120 -10 *0.4
                this.allBookTableHeight =
                    (innerHeight - 130) * 0.6 - 37 > 400
                        ? (innerHeight - 130) * 0.6 - 37
                        : 400;
                this.functionTabHeight =
                    innerHeight - 130 - this.allBookTableHeight - 37 > 200
                        ? innerHeight - 130 - this.allBookTableHeight - 37
                        : 200;
            }
        },
        onResize() {
            this.setHeights();
        },
        loadMTDVolume() {
            const self = this;
            const params = { book_list: this.bookList };
            getMTDVolume(params).then((res) => {
                if (typeof res.data === "string") {
                    const output = res.data.replaceAll(NaN, null);
                    self.mtdVolume = JSON.parse(output);
                } else {
                    self.mtdVolume = res.data;
                }
            });
        },
        loadMTDPnl() {
            const self = this;
            const params = { book_list: this.bookList };

            getMTDPnl(params).then((res) => {
                if (typeof res.data === "string") {
                    const output = res.data.replaceAll(NaN, null);
                    self.mtdPnl = JSON.parse(output);
                } else {
                    self.mtdPnl = res.data;
                }
            });
        },
        onMenuItemClick(item) {
            this.selectedBook = item;
        },
        rowClicked(data) {
            const symbolSnapshot = {
                long: parseFloat(data.longPositions),
                short: parseFloat(data.shortPositions),
                net: parseFloat(data.net),
                realized: parseFloat(data.closedProfitEOD),
                unrealized: parseFloat(data.floatingProfitEOD),
                dailyNet: parseFloat(data.dailyNet),
            };
            this.UPDATE_SYMBOL_SNAPSHOT(symbolSnapshot);
            if (this.monitorDialog === false) {
                if (this.currentExpanded === data.symbol) {
                    this.monitorDialog = true;
                } else {
                    this.currentExpanded = data.symbol;
                    this.symbolLoginDetailArray = [];
                    this.$nextTick(() => {
                        this.sendExpandSymbolRequest();
                    });
                }
            } else {
                if (this.currentExpanded !== data.symbol) {
                    this.currentExpanded = data.symbol;
                    this.symbolLoginDetailArray = [];
                    this.$nextTick(() => {
                        this.sendExpandSymbolRequest();
                    });
                }
            }
        },
        sendExpandSymbolRequest() {
            if (this.selectedMode.title === "Login") {
                this.monitorDialog = true;
                this.monitorDialogLoading = true;
                const pullCommand = {
                    externalMsgType:
                        "CMD_PULL_BOOK_SYMBOL_RESULT_FOR_LOGIN_MODE",
                    login: this.currentExpanded,
                    book: this.selectedBook,
                    ref:
                        this.selectedBook +
                        "|" +
                        this.currentExpanded +
                        "|" +
                        this.selectedMode.value,
                };
                this.fetchDetail(pullCommand);
            }
            if (this.selectedMode.title === "Symbol") {
                this.monitorDialog = true;
                this.monitorDialogLoading = true;
                const pullCommand = {
                    externalMsgType: "CMD_PULL_BOOK_SYMBOL_RESULT",
                    symbol: this.currentExpanded,
                    book: this.selectedBook,
                    ref:
                        this.selectedBook +
                        "|" +
                        this.currentExpanded +
                        "|" +
                        this.selectedMode.value,
                };
                this.fetchDetail(pullCommand);
            }
        },
        changeSelectedBook(book) {
            this.selectedBook = book;
        },
        // 分批处理数据，最后一次性更新响应式数据
        processDataInBatches(items, processItem, batchSize = 200, onComplete) {
            const keys = Object.keys(items);
            let index = 0;

            // 生成新的批处理ID，用于取消过时的处理
            const currentBatchId = ++this.processingBatchId;

            // 复制当前数据到普通数组（非响应式）
            const tempData = [...this.pkData];
            const tempIndexMap = new Map(this.pkDataIndexMap);

            const processBatch = () => {
                // 如果有新的批处理启动，取消当前处理
                if (currentBatchId !== this.processingBatchId) {
                    return;
                }

                const endIndex = Math.min(index + batchSize, keys.length);

                for (; index < endIndex; index++) {
                    const key = keys[index];
                    // 传入临时数据进行处理
                    processItem(key, items[key], tempData, tempIndexMap);
                }

                if (index < keys.length) {
                    // 还有数据，用 setTimeout 让出主线程
                    setTimeout(processBatch, 0);
                } else {
                    // 处理完成，一次性更新响应式数据
                    this.pkData = tempData;
                    this.pkDataIndexMap = tempIndexMap;
                    if (onComplete) onComplete();
                }
            };

            processBatch();
        },
        filterTable(value, search, item) {
            return (
                value !== null &&
                search !== null &&
                typeof value === "string" &&
                value.toString().toLowerCase().indexOf(search.toLowerCase()) !==
                    -1
            );
        },
        customSort(items, sortBy, sortDesc) {
            items.sort((a, b) => {
                if (sortBy[0] === "net") {
                    if (!sortDesc[0]) {
                        return (
                            Math.abs(a.longPositions - a.shortPositions) -
                            Math.abs(b.longPositions - b.shortPositions)
                        );
                    }
                    if (sortDesc[0]) {
                        return (
                            Math.abs(b.longPositions - b.shortPositions) -
                            Math.abs(a.longPositions - a.shortPositions)
                        );
                    }
                } else if (sortBy[0] === "dailyNet") {
                    if (!sortDesc[0]) {
                        return (
                            a.floatingProfitEOD +
                            a.closedProfitEOD -
                            (b.floatingProfitEOD + b.closedProfitEOD)
                        );
                    }
                    if (sortDesc[0]) {
                        return (
                            b.floatingProfitEOD +
                            b.closedProfitEOD -
                            (a.floatingProfitEOD + a.closedProfitEOD)
                        );
                    }
                } else if (sortBy[0] === "symbol") {
                    if (!sortDesc[0]) return a.symbol.localeCompare(b.symbol);
                    if (sortDesc[0]) return b.symbol.localeCompare(a.symbol);
                } else if (
                    sortBy[0] === "floatingProfitEOD" ||
                    sortBy[0] === "floatingProfit" ||
                    sortBy[0] === "closedProfit" ||
                    sortBy[0] === "closedProfitEOD"
                ) {
                    if (!sortDesc[0]) {
                        return a[sortBy[0]] - b[sortBy[0]];
                    }
                    if (sortDesc[0]) {
                        return b[sortBy[0]] - a[sortBy[0]];
                    }
                } else if (sortBy[0] === "symbolExposure") {
                    if (!sortDesc[0]) {
                        return Math.abs(a[sortBy[0]]) - Math.abs(b[sortBy[0]]);
                    }
                    if (sortDesc[0]) {
                        return Math.abs(b[sortBy[0]]) - Math.abs(a[sortBy[0]]);
                    }
                } else {
                    if (!sortDesc[0]) {
                        return a[sortBy] < b[sortBy] ? -1 : 1;
                    } else {
                        return b[sortBy] < a[sortBy] ? -1 : 1;
                    }
                }
            });
            return items;
        },
        changeTab(key) {
            this.selectedKey = key;
            if (key !== "raw") {
                this.dialogWidth = "500px";
            } else {
                this.dialogWidth = "1200px";
            }

            const params = {
                symbol: this.closeSummarySymbol,
                book: this.selectedBook,
                date: common.getMT4TimeString().split(" ")[0] + " 00:00:00",
                key: this.selectedKey,
            };
            this.getPNLSummaryAction(params);
        },
        loadLoginSummaryHistoryDialog(item) {
            const symbolSnapshot = {
                long: parseFloat(item.longPositions),
                short: parseFloat(item.shortPositions),
                net: parseFloat(item.netPositions),
                realized: parseFloat(item.closedProfitEOD),
                unrealized: parseFloat(item.floatingProfitEOD),
                dailyNet: parseFloat(item.dailyNet),
            };
            this.UPDATE_LOGIN_SNAPSHOT(symbolSnapshot);
            if (!this.showHomeLoginDetailSummary) {
                return;
            }
            // split login string to get login value
            const [server, login] = item.login.split(":");
            this.fullLoginValue = item.fullLogin;
            this.loginValue = login;
            this.serverValue = server;
            this.symbolValue = this.currentExpanded;

            this.loginSummaryHistoryVisible = false;
            this.$nextTick(() => {
                this.loginSummaryHistoryVisible = true;
            });
        },
        async onWebSocketOpen(evt) {
            try {
                const res = await getWsToken();
                const data = {
                    token: res.data.ws_token,
                    externalMsgType: "CMD_AUTHORIZATION",
                };
                this.pkSocket.send(JSON.stringify(data));
                // resend expanded request
                if (this.currentExpanded) {
                    this.sendExpandSymbolRequest();
                }
            } catch (error) {
                console.error("Failed to get WebSocket token:", error);
            }
        },
        onWebSocketMessage(evt) {
            let msg = evt.data;
            msg = msg.replace("$_", "");
            const ORIGIN_HASH_MSG = md5(msg);

            // decode data
            let decodedMsg = this.unzipVersion(msg);
            // if data is in string format, parse it
            if (typeof decodedMsg === "string" && decodedMsg !== "") {
                decodedMsg = JSON.parse(decodedMsg);
            }
            if (decodedMsg === null) return;
            // console.log("mdd1", md5(decodedMsg));

            // console.log(decodedMsg);

            if (decodedMsg.code === "INVALID_PERMISSION") {
                getWsToken()
                    .then((res) => {
                        const data = {
                            token: res.data.ws_token,
                            externalMsgType: "CMD_AUTHORIZATION",
                        };
                        this.pkSocket.send(JSON.stringify(data));
                    })
                    .catch((error) => {
                        console.error("Failed to get WebSocket token:", error);
                    });
            }
            if (
                decodedMsg.externalMsgType === "RESPONSE_AUTH" &&
                decodedMsg.code === "OK"
            ) {
                const bookMain = {
                    externalMsgType: "CMD_SUBSCRIBE_BOOKS",
                    books: [this.selectedBook + ":" + this.selectedMode.value],
                };
                this.pkSocket.send(JSON.stringify(bookMain));

                const bookBrief = {
                    externalMsgType: "CMD_SUBSCRIBE_BOOKS_BRIEF",
                    books: this.bookList.map(
                        (book) => book + ":" + this.selectedMode.value
                    ),
                };

                this.pkSocket.send(JSON.stringify(bookBrief));
            }
            if (
                decodedMsg.externalMsgType === "RESPONSE_SUBSCRIBE_BOOKS" ||
                decodedMsg.externalMsgType === "RESPONSE_SUBSCRIBE_BOOKS_BRIEF"
            ) {
                this.isDataStreaming = true;
            }
            if (
                decodedMsg.externalMsgType === "RESPONSE_SUBSCRIBE_BOOKS" &&
                decodedMsg.code === "OK"
            ) {
                clearInterval(this.detailHBInterval);
                if (this.selectedDetailInterval > 0) {
                    const changeMode = {
                        externalMsgType: "CMD_CHANGE_SUBSCRIBE_MODE",
                        mode: "PULL",
                    };
                    this.pkSocket.send(JSON.stringify(changeMode));
                    const pullCommand = {
                        externalMsgType: "CMD_PULL_BOOK_RESULT",
                        mode: "detail",
                        books: [
                            this.selectedBook + ":" + this.selectedMode.value,
                        ],
                    };
                    this.pkSocket.send(JSON.stringify(pullCommand));
                } else {
                    const modeChange = {
                        externalMsgType: "CMD_CHANGE_SUBSCRIBE_MODE",
                        mode: "PUSH",
                    };
                    this.pkSocket.send(JSON.stringify(modeChange));
                    this.detailHBInterval = setInterval(() => {
                        const heartBeat = {
                            externalMsgType: "CMD_SUBSCRIBE_HEART_BEAT",
                        };
                        this.pkSocket.send(JSON.stringify(heartBeat));
                    }, 60000);
                }
            }
            if (
                decodedMsg.externalMsgType ===
                    "RESPONSE_SUBSCRIBE_BOOKS_BRIEF" &&
                decodedMsg.code === "OK"
            ) {
                clearInterval(this.allBookHBInterval);
                if (this.selectedInterval > 0) {
                    const changeMode = {
                        externalMsgType: "CMD_CHANGE_SUBSCRIBE_MODE",
                        mode: "PULL",
                    };
                    this.pkSocket.send(JSON.stringify(changeMode));
                    const pullCommand = {
                        externalMsgType: "CMD_PULL_BOOK_RESULT",
                        mode: "brief",
                        books: this.bookList.map(
                            (book) => book + ":" + this.selectedMode.value
                        ),
                    };
                    this.pkSocket.send(JSON.stringify(pullCommand));
                } else {
                    const modeChange = {
                        externalMsgType: "CMD_CHANGE_SUBSCRIBE_MODE",
                        mode: "PUSH",
                    };
                    this.pkSocket.send(JSON.stringify(modeChange));
                    this.allBookHBInterval = setInterval(() => {
                        const heartBeat = {
                            externalMsgType: "CMD_SUBSCRIBE_HEART_BEAT",
                        };
                        this.pkSocket.send(JSON.stringify(heartBeat));
                    }, 60000);
                }
            }

            // symbol detail
            if (
                decodedMsg.externalMsgType === "DATA_BOOK_PROFIT_SYMBOL_RESULT"
            ) {
                // console.log(decodedMsg);
                const matchingRef =
                    this.selectedBook +
                        "|" +
                        this.currentExpanded +
                        "|" +
                        this.selectedMode.value ===
                    decodedMsg?.ref;

                if (this.currentExpanded !== "" && matchingRef) {
                    // hash code is diff then update detail data
                    if (ORIGIN_HASH_MSG !== this.symbolLoginDetailOriginHash) {
                        if (this.isCsvRecording) {
                            this.symbolLoginDetails =
                                decodedMsg.userProfitDetailsBySymbolHashMap;
                            this.isCsvRecording = false;
                        }
                        // console.log(decodedMsg)
                        const expandMap =
                            decodedMsg.userProfitDetailsBySymbolHashMap;
                        const digits = decodedMsg.digits;

                        const expandData = [];
                        for (const item in expandMap) {
                            // console.log(expandMap[item])
                            const {
                                longPositions,
                                shortPositions,
                                netPositions,
                                floatingProfitEOD,
                                closedProfitEOD,
                                floatingProfit,
                                login,
                                closedProfit,
                                symbol,
                                weightedAvgLongPrice,
                                weightedAvgShortPrice,
                                exposure,
                                dailyVolumeUSD,
                            } = expandMap[item];
                            expandData.push({
                                fullLogin: login,
                                login:
                                    login.split(":")[1] +
                                    ":" +
                                    login.split(":")[2],
                                longPositions: this.numberWithCommas(
                                    longPositions.toFixed(this.lotDigits)
                                ),
                                shortPositions: this.numberWithCommas(
                                    shortPositions.toFixed(this.lotDigits)
                                ),
                                netPositions: this.numberWithCommas(
                                    netPositions.toFixed(this.lotDigits)
                                ),
                                dailyNet: this.numberWithCommas(
                                    (
                                        floatingProfitEOD + closedProfitEOD
                                    ).toFixed(2)
                                ),
                                floatingProfitEOD: this.numberWithCommas(
                                    floatingProfitEOD.toFixed(2)
                                ),
                                floatingProfit: this.numberWithCommas(
                                    floatingProfit.toFixed(2)
                                ),
                                closedProfitEOD: this.numberWithCommas(
                                    closedProfitEOD.toFixed(2)
                                ),
                                closedProfit: this.numberWithCommas(
                                    closedProfit.toFixed(2)
                                ),
                                dailyVolumeUSD: this.numberWithCommas(
                                    (dailyVolumeUSD ?? 0).toFixed(2)
                                ),
                                weightedAvgLongPrice:
                                    weightedAvgLongPrice.toFixed(digits),
                                weightedAvgShortPrice:
                                    weightedAvgShortPrice.toFixed(digits),
                                exposure: this.numberWithCommas(
                                    exposure.toFixed(2)
                                ),
                            });
                        }
                        this.symbolLoginDetailArray = expandData;
                        this.monitorDialogLoading = false;
                        this.symbolLoginDetailOriginHash = ORIGIN_HASH_MSG;
                    }

                    // repull expanded data
                    const pullCommand = {
                        externalMsgType: "CMD_PULL_BOOK_SYMBOL_RESULT",
                        symbol: this.currentExpanded,
                        book: this.selectedBook,
                        ref:
                            this.selectedBook +
                            "|" +
                            this.currentExpanded +
                            "|" +
                            this.selectedMode.value,
                    };

                    if (!!this.monitorDialog) {
                        if (this.selectedDetailInterval > 0) {
                            setTimeout(() => {
                                this.fetchDetail(pullCommand);
                            }, this.selectedDetailInterval);
                        } else {
                            setTimeout(() => {
                                this.fetchDetail(pullCommand);
                            }, 1000);
                        }
                    } else {
                        this.currentExpanded = undefined;
                        this.symbolLoginDetailOriginHash = undefined;
                    }
                }
            }

            // login detail
            if (
                decodedMsg.externalMsgType ===
                "DATA_BOOK_LOGIN_SYMBOL_PROFIT_LOGIN_MODE_RESULT"
            ) {
                // console.log(decodedMsg);
                const matchingRef =
                    this.selectedBook +
                        "|" +
                        this.currentExpanded +
                        "|" +
                        this.selectedMode.value ===
                    decodedMsg?.ref;

                if (this.currentExpanded !== "" && matchingRef) {
                    // hash code is diff then update detail data
                    if (ORIGIN_HASH_MSG !== this.symbolLoginDetailOriginHash) {
                        if (this.isCsvRecording) {
                            this.symbolLoginDetails =
                                decodedMsg.symbolProfitForSpecificLoginMap;
                            this.isCsvRecording = false;
                        }
                        // console.log(decodedMsg);
                        const expandMap =
                            decodedMsg.symbolProfitForSpecificLoginMap;

                        const expandData = [];
                        for (const item in expandMap) {
                            // console.log(item, expandMap[item])
                            const {
                                longPositions,
                                shortPositions,
                                floatingProfitEOD,
                                closedProfitEOD,
                                floatingProfit,
                                closedProfit,
                                weightedAvgLongPrice,
                                weightedAvgShortPrice,
                                symbolExposure,
                                digits,
                                dailyVolumeUSD,
                            } = expandMap[item];
                            expandData.push({
                                symbol: item,
                                longPositions: this.numberWithCommas(
                                    longPositions.toFixed(this.lotDigits)
                                ),
                                shortPositions: this.numberWithCommas(
                                    shortPositions.toFixed(this.lotDigits)
                                ),
                                netPositions: this.numberWithCommas(
                                    (longPositions - shortPositions).toFixed(
                                        this.lotDigits
                                    )
                                ),
                                dailyNet: this.numberWithCommas(
                                    (
                                        floatingProfitEOD + closedProfitEOD
                                    ).toFixed(2)
                                ),
                                floatingProfitEOD: this.numberWithCommas(
                                    floatingProfitEOD.toFixed(2)
                                ),
                                floatingProfit: this.numberWithCommas(
                                    floatingProfit.toFixed(2)
                                ),
                                closedProfitEOD: this.numberWithCommas(
                                    closedProfitEOD.toFixed(2)
                                ),
                                closedProfit: this.numberWithCommas(
                                    closedProfit.toFixed(2)
                                ),
                                dailyVolumeUSD: this.numberWithCommas(
                                    (dailyVolumeUSD ?? 0).toFixed(2)
                                ),
                                weightedAvgLongPrice:
                                    weightedAvgLongPrice.toFixed(digits),
                                weightedAvgShortPrice:
                                    weightedAvgShortPrice.toFixed(digits),
                                exposure: this.numberWithCommas(
                                    symbolExposure.toFixed(2)
                                ),
                            });
                        }
                        this.symbolLoginDetailArray = expandData;
                        this.monitorDialogLoading = false;
                        this.symbolLoginDetailOriginHash = ORIGIN_HASH_MSG;
                    }

                    // repull expanded data
                    const pullCommand = {
                        externalMsgType:
                            "CMD_PULL_BOOK_SYMBOL_RESULT_FOR_LOGIN_MODE",
                        login: this.currentExpanded,
                        book: this.selectedBook,
                        ref:
                            this.selectedBook +
                            "|" +
                            this.currentExpanded +
                            "|" +
                            this.selectedMode.value,
                    };

                    if (!!this.monitorDialog) {
                        if (this.selectedDetailInterval > 0) {
                            setTimeout(() => {
                                this.fetchDetail(pullCommand);
                            }, this.selectedDetailInterval);
                        } else {
                            setTimeout(() => {
                                this.fetchDetail(pullCommand);
                            }, 1000);
                        }
                    } else {
                        this.currentExpanded = undefined;
                        this.symbolLoginDetailOriginHash = undefined;
                    }
                }
            }

            if (
                decodedMsg.externalMsgType === "DATA_BOOK_PROFIT_BRIEF_RESULT"
            ) {
                this.calculateAllBooks(decodedMsg);
                // console.log(decodedMsg)
                if (this.selectedDetailInterval > 0) {
                    setTimeout(() => {
                        if (this.pkSocket.readyState === 1) {
                            const pullCommand = {
                                externalMsgType: "CMD_PULL_BOOK_RESULT",
                                mode: "brief",
                                books: [
                                    decodedMsg.book +
                                        ":" +
                                        this.selectedMode.value,
                                ],
                            };
                            this.pkSocket.send(JSON.stringify(pullCommand));
                        }
                    }, this.selectedInterval);
                }
            }

            // if return data is about streaming, handle data to make the table updated
            if (decodedMsg.externalMsgType === "DATA_BOOK_PROFIT_RESULT") {
                // console.log(decodedMsg);
                const td = decodedMsg.profitSymbolDetailMap;

                if (
                    this.selectedBook === decodedMsg.book &&
                    decodedMsg.ibType === this.selectedMode.value
                ) {
                    this.mainBookTitle = {
                        unrealized: decodedMsg.floatingProfitsEOD,
                        realized: decodedMsg.closedProfitsEOD,
                        dailyNet:
                            decodedMsg.floatingProfitsEOD +
                            decodedMsg.closedProfitsEOD,
                    };

                    this.processDataInBatches(
                        td,
                        (item, dataItem, tempData, tempIndexMap) => {
                            const {
                                longPositions,
                                shortPositions,
                                floatingProfitEOD,
                                closedProfitEOD,
                                eodPriceMap,
                                floatingProfit,
                                closedProfit,
                                symbolExposure,
                                weightedAvgLongPrice,
                                weightedAvgShortPrice,
                                digits,
                            } = dataItem;
                            dataItem.symbol = item;

                            dataItem._eodPriceList = [];
                            for (const symbolName in eodPriceMap) {
                                const [ask, bid, dateTime] =
                                    eodPriceMap[symbolName].split(",");
                                dataItem._eodPriceList.push({
                                    symbolName,
                                    ask,
                                    bid,
                                    dateTime: this.toMTTimeString(dateTime),
                                });
                            }
                            dataItem.net = this.roundDecimal(
                                longPositions - shortPositions,
                                this.lotDigits
                            );

                            dataItem.netStr = this.numberWithCommas(
                                this.roundDecimal(
                                    longPositions - shortPositions,
                                    this.lotDigits
                                )
                            );
                            dataItem.dailyNet = this.roundDecimal(
                                floatingProfitEOD + closedProfitEOD,
                                2
                            );
                            dataItem.dailyNetStr = this.numberWithCommas(
                                this.roundDecimal(
                                    floatingProfitEOD + closedProfitEOD,
                                    2
                                )
                            );
                            dataItem.symbolExposureStr = this.numberWithCommas(
                                symbolExposure.toFixed(2)
                            );
                            dataItem.floatingProfitStr = this.numberWithCommas(
                                floatingProfit.toFixed(2)
                            );
                            dataItem.longPositionsStr = this.numberWithCommas(
                                longPositions.toFixed(this.lotDigits)
                            );
                            dataItem.shortPositionsStr = this.numberWithCommas(
                                shortPositions.toFixed(this.lotDigits)
                            );
                            dataItem.floatingProfitEODStr =
                                this.numberWithCommas(
                                    floatingProfitEOD.toFixed(2)
                                );
                            dataItem.closedProfitEODStr = this.numberWithCommas(
                                closedProfitEOD.toFixed(2)
                            );
                            dataItem.closedProfitStr = this.numberWithCommas(
                                closedProfit.toFixed(2)
                            );
                            dataItem.weightedAvgLongPriceStr =
                                weightedAvgLongPrice.toFixed(digits);
                            dataItem.weightedAvgShortPriceStr =
                                weightedAvgShortPrice.toFixed(digits);
                            const foundIndex = tempIndexMap.get(item);
                            const found =
                                foundIndex !== undefined
                                    ? tempData[foundIndex]
                                    : undefined;
                            if (!found) {
                                dataItem.color = "";
                                dataItem.realizedColor = "";
                                tempIndexMap.set(item, tempData.length);
                                tempData.push(Object.freeze(dataItem));
                            } else {
                                dataItem.color =
                                    Number(found?.dailyNet) >
                                    Number(dataItem?.dailyNet)
                                        ? "green"
                                        : Number(found?.dailyNet) ===
                                          Number(dataItem?.dailyNet)
                                        ? ""
                                        : "red";

                                dataItem.realizedColor =
                                    Number(found?.closedProfitEOD) >
                                    Number(dataItem?.closedProfitEOD)
                                        ? "green"
                                        : Number(found?.closedProfitEOD) ===
                                          Number(dataItem?.closedProfitEOD)
                                        ? found.realizedColor
                                        : "red";
                                tempData.splice(
                                    foundIndex,
                                    1,
                                    Object.freeze(dataItem)
                                );
                            }
                        },
                        200,
                        () => {
                            if (
                                Object.keys(this.exposureData).length == 0 ||
                                parseInt(Date.now() / 1000) % 5 == 0
                            ) {
                                this.UPDATE_EXPOSURE_DATA(
                                    Object.freeze(decodedMsg.exposureMap)
                                );
                            }
                        }
                    );

                    if (this.selectedDetailInterval > 0) {
                        this.bookMainTimeout = setTimeout(() => {
                            if (this.pkSocket.readyState === 1) {
                                const pullCommand = {
                                    externalMsgType: "CMD_PULL_BOOK_RESULT",
                                    mode: "detail",
                                    books: [
                                        this.selectedBook +
                                            ":" +
                                            this.selectedMode.value,
                                    ],
                                };
                                this.pkSocket.send(JSON.stringify(pullCommand));
                            }
                        }, this.selectedDetailInterval);
                    }
                }
            }

            if (
                decodedMsg.externalMsgType ===
                "DATA_BOOK_LOGIN_PROFIT_FOR_LOGIN_MODE"
            ) {
                // console.log(decodedMsg);
                const td = decodedMsg.UserProfitInfoMap;

                if (
                    this.selectedBook === decodedMsg.book &&
                    decodedMsg.ibType === this.selectedMode.value
                ) {
                    this.mainBookTitle = {
                        unrealized: decodedMsg.floatingProfitsEOD,
                        realized: decodedMsg.closedProfitsEOD,
                        dailyNet:
                            decodedMsg.floatingProfitsEOD +
                            decodedMsg.closedProfitsEOD,
                    };

                    this.processDataInBatches(
                        td,
                        (item, dataItem, tempData, tempIndexMap) => {
                            const {
                                Login,
                                Name,
                                Exposure,
                                floatingProfitEOD,
                                closedProfitEOD,
                                eodPriceMap,
                                floatingProfit,
                                closedProfit,
                                TodayTotalMTPNL,
                                Equity,
                                MarginLevel,
                            } = dataItem;
                            dataItem.Name = this.decodeMaybeHexOrGarbled(
                                dataItem.Name
                            );
                            dataItem.symbol = item;

                            dataItem._eodPriceList = [];
                            for (const symbolName in eodPriceMap) {
                                const [ask, bid, dateTime] =
                                    eodPriceMap[symbolName].split(",");
                                dataItem._eodPriceList.push({
                                    symbolName,
                                    ask,
                                    bid,
                                    dateTime: this.toMTTimeString(dateTime),
                                });
                            }
                            dataItem.dailyNet = this.roundDecimal(
                                floatingProfitEOD + closedProfitEOD,
                                2
                            );
                            dataItem.dailyNetStr = this.numberWithCommas(
                                this.roundDecimal(
                                    floatingProfitEOD + closedProfitEOD,
                                    2
                                )
                            );
                            dataItem.floatingProfitStr = this.numberWithCommas(
                                floatingProfit.toFixed(2)
                            );
                            dataItem.floatingProfitEODStr =
                                this.numberWithCommas(
                                    floatingProfitEOD.toFixed(2)
                                );
                            dataItem.closedProfitEODStr = this.numberWithCommas(
                                closedProfitEOD.toFixed(2)
                            );
                            dataItem.closedProfitStr = this.numberWithCommas(
                                closedProfit.toFixed(2)
                            );
                            const foundIndex = tempIndexMap.get(item);
                            const found =
                                foundIndex !== undefined
                                    ? tempData[foundIndex]
                                    : undefined;
                            if (!found) {
                                dataItem.color = "";
                                dataItem.realizedColor = "";
                                tempIndexMap.set(item, tempData.length);
                                tempData.push(Object.freeze(dataItem));
                            } else {
                                dataItem.color =
                                    Number(found?.dailyNet) >
                                    Number(dataItem?.dailyNet)
                                        ? "green"
                                        : Number(found?.dailyNet) ===
                                          Number(dataItem?.dailyNet)
                                        ? ""
                                        : "red";

                                dataItem.realizedColor =
                                    Number(found?.closedProfitEOD) >
                                    Number(dataItem?.closedProfitEOD)
                                        ? "green"
                                        : Number(found?.closedProfitEOD) ===
                                          Number(dataItem?.closedProfitEOD)
                                        ? found.realizedColor
                                        : "red";
                                tempData.splice(
                                    foundIndex,
                                    1,
                                    Object.freeze(dataItem)
                                );
                            }
                        },
                        200,
                        () => {
                            if (
                                Object.keys(this.exposureData).length == 0 ||
                                parseInt(Date.now() / 1000) % 5 == 0
                            ) {
                                this.UPDATE_EXPOSURE_DATA(
                                    Object.freeze(decodedMsg.exposureMap)
                                );
                            }
                        }
                    );

                    if (this.selectedDetailInterval > 0) {
                        this.bookMainTimeout = setTimeout(() => {
                            if (this.pkSocket.readyState === 1) {
                                const pullCommand = {
                                    externalMsgType: "CMD_PULL_BOOK_RESULT",
                                    mode: "detail",
                                    books: [
                                        this.selectedBook +
                                            ":" +
                                            this.selectedMode.value,
                                    ],
                                };
                                this.pkSocket.send(JSON.stringify(pullCommand));
                            }
                        }, this.selectedDetailInterval);
                    }
                }
            }
        },
        fetchDetail(request) {
            this.pkSocket.send(JSON.stringify(request));
        },
        onWindowFocus() {
            if (this.pkSocket == null || this.pkSocket.readyState == 3) {
                const lastSelection = this.selectedProfile;
                this.UPDATE_SELECTED_PROFILE(null);
                this.UPDATE_SELECTED_PROFILE(lastSelection);
            }
        },
        initConnection() {
            this.snackBarInfo(
                this.$t("monitor.home.connectingToSocket"),
                10000
            );
            this.selectedBook = null;
            this.isDataStreaming = false;
        },
        // call this function to auto focus onto the search input field
        onSearch(field) {
            setTimeout(() => {
                this.$refs[field].focus();
            }, 200);
        },
        getPNLSummary(data) {
            this.dialogCloseSummaryVisible = true;
            this.closeSummarySymbol = data.symbol;
            const params = {
                symbol: this.closeSummarySymbol,
                book: this.selectedBook,
                date: common.getMT4TimeString().split(" ")[0] + " 00:00:00",
                key: this.selectedKey,
            };
            this.getPNLSummaryAction(params);
        },
        getEODSymbolMaps(data) {
            this.symbolMap = true;
            this.selectedSymbolMap = data;
        },
        toMTTimeString(timestamp) {
            const utc = require("dayjs/plugin/utc");
            const timezone = require("dayjs/plugin/timezone");
            dayjs.extend(utc);
            dayjs.extend(timezone);
            const date = dayjs
                .unix(timestamp)
                .tz("UTC")
                .format("YYYY-MM-DD HH:mm:ss");
            return date;
        },
    },
    created() {
        // window.addEventListener("keypress", (e) => {
        //     if (e.key === "q") {
        //         this.pkSocket.close();
        //     }
        // });
        // window.addEventListener("focus", this.onWindowFocus);

        const userFunction = this.getFunction("book");

        if (userFunction.includes("homeLoginDetailSummary")) {
            this.showHomeLoginDetailSummary = true;
        }
        if (userFunction.includes("extraSymbolDetails")) {
            this.allowSymbolDetailsDownload = true;
        }
        if (userFunction.includes("allowDownloadAll")) {
            this.allowDownloadAll = true;
        }
        if (userFunction.includes("symbolLoginSwitch")) {
            this.showSymbolLoginSwitch = true;
        }
        if (userFunction.includes("mtdVolumeColumn")) {
            this.showMtdVolume = true;
        }
        if (userFunction.includes("mtdPnlColumn")) {
            this.showMtdPnl = true;
        }
        if (userFunction.includes("netEquityColumn")) {
            this.showNetEquity = true;
        }
        document.addEventListener("visibilitychange", this.userFocus);

        const mode = localStorage.getItem("bookMonitorMode");

        if (mode === "Login") {
            this.selectedMode = { title: "Login", value: "LOGIN" };
        } else {
            this.selectedMode = { title: "Symbol", value: "NOT_IB" };
        }

        var localSavedMainHeader = localStorage.getItem("mainHeader");

        if (localSavedMainHeader) {
            this.mainHeader = JSON.parse(localSavedMainHeader);
        } else {
            this.mainHeader = deepClone(this.pkHeaders);
        }

        // call getBooks actions to load books
        this.getBooksPkAction();
        this.getServerAction();
    },
    destroyed() {
        if (this.pkSocket !== null) {
            this.pkSocket.close();
        }

        // window.removeEventListener("focus", this.onWindowFocus);
        clearInterval(this.allBookHBInterval);
        clearInterval(this.detailHBInterval);
    },
};
</script>

<style lang="scss" scoped>
.green {
    background-color: #27ae60;
}

.red {
    background-color: #c0392b;
}

.td-alert {
    background-color: #c0392b;
}
.hover-login-tooltip:hover {
    cursor: pointer;
}
.symbol-detail:hover {
    cursor: pointer;
}

#home-table table > tbody {
    /* height: 600px; */
    overflow-y: scroll;
}
#home-table
    > div.v-data-table__wrapper
    > table
    > tbody
    > tr.v-data-table__expanded.v-data-table__expanded__content
    > td
    > div.v-data-table.v-data-table--dense.v-data-table--fixed-header.theme--dark
    > div
    > table
    > tbody
    > tr:nth-child(n) {
    height: 32px;
}
#home-table
    > div.v-data-table__wrapper
    > table
    > tbody
    > tr.v-data-table__expanded.v-data-table__expanded__content
    > td
    > div.v-data-table.v-data-table--dense.v-data-table--fixed-header.theme--dark
    > div
    > table
    > tbody {
    height: 32px;
}
.home-checkbox .v-label {
    font-size: 12px;
}
.home-checkbox .v-messages {
    display: none;
}
#global-container
    > div.home
    > div
    > div
    > div:nth-child(5)
    > div:nth-child(2)
    > div.col-md-5.col-lg-5.col-12
    > div:nth-child(2)
    > div:nth-child(n)
    > button:hover {
    background-color: #2196f3;
}
#home-table > div.v-data-table__wrapper > table > tbody > tr:nth-child(n) {
    height: 19px;
}
#home-table
    > div.v-data-table__wrapper
    > table
    > tbody
    > tr.v-data-table__expanded.v-data-table__expanded__row:nth-child(n) {
    height: 32px;
}

#home-table table > tbody::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
}

#home-table table > tbody::-webkit-scrollbar {
    width: 12px;
    background-color: #f5f5f5;
}

#home-table table > tbody::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);

    background-color: #555;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 14px;
}

.v-btn:not(.v-btn--round).v-size--small {
    height: 19px;
}
.v-tab {
    padding: 0 7px;
}

.no_break {
    white-space: nowrap;
}
</style>
